<template>
    <div class="cp-favorite-tickets__slider-wrapper">
        <div ref="container" class="keen-slider cp-favorite-tickets__slider">
            <TransitionGroup
                name="slide"
                @after-appear="slider.update()"
                @after-enter="slider.update()"
                @after-leave="slider.update()"
            >
                <div
                    v-for="ticket in favoriteTickets"
                    :key="ticket.externalSystemID"
                    class="keen-slider__slide cp-favorite-tickets__slide"
                >
                    <TicketPromoCard :card="ticket" />
                </div>
            </TransitionGroup>
        </div>
        <Transition name="fade">
            <div class="cp-favorite-tickets__buttons" v-if="slider && areButtonsVisible">
                <DsButton
                    @click="slider.prev()"
                    :is-disabled="isButtonLeftDisabled"
                    size="sm"
                    class="cp-favorite-tickets__button"
                    icon-left="arrow-left"
                    type="interaction"
                    aria-label="Předchozí slide"
                />
                <DsButton
                    @click="slider.next()"
                    :is-disabled="isButtonRightDisabled"
                    size="sm"
                    class="cp-favorite-tickets__button"
                    icon-left="arrow-right"
                    type="interaction"
                    aria-label="Následujicí slide"
                />
            </div>
        </Transition>
    </div>
</template>
<script setup lang="ts">
import { useKeenSlider } from "keen-slider/vue";
import { FavoriteTicket } from "../models/favorite-ticket";
import TicketPromoCard from "./ticket-promo-card.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { useKeenSliderConfig } from "../composables/use-keen-slider-config";

defineProps<{
    favoriteTickets: FavoriteTicket[];
}>();

const { config, areButtonsVisible, isButtonLeftDisabled, isButtonRightDisabled } = useKeenSliderConfig();

const [container, slider] = useKeenSlider({ ...config });
</script>
<style>
.slide-move,
.slide-enter-active,
.slide-leave-active {
    transition: all 0.25s;
}

.slide-enter-from,
.slide-leave-to {
    opacity: 0;
}

.slide-enter-active:nth-child(2) {
    transform: translateX(12px);
}

.slide-enter-active:nth-child(3) {
    transform: translateX(24px);
}

.slide-enter-active:nth-child(4) {
    transform: translateX(36px);
}

.slide-enter-active:nth-child(5) {
    transform: translateX(48px);
}

.slide-leave-active {
    position: absolute;
}
</style>
